import { createContext, useContext, useRef } from "react";
import ModelReprocessDialog, { ReprocessDialogRef } from ".";
import { ModelStatus } from "../../../../models/Model";

const ModelReprocessDialogContext = createContext<{
  openDialog: (model: { id: string; status: ModelStatus }) => void;
  closeDialog: () => void;
} | null>(null);

export const useModelReprocessDialog = () => {
  const context = useContext(ModelReprocessDialogContext);
  if (!context) {
    throw new Error(
      "useReprocessDialog must be used within a ReprocessDialogProvider"
    );
  }
  return context;
};

export const ModelReprocessDialogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const ref = useRef<ReprocessDialogRef>(null);

  const openDialog = (model: { id: string; status: ModelStatus }) => {
    ref.current?.openDialog(model);
  };

  const closeDialog = () => {
    ref.current?.closeDialog();
  };

  return (
    <ModelReprocessDialogContext.Provider
      value={{
        openDialog,
        closeDialog,
      }}
    >
      {children}
      <ModelReprocessDialog ref={ref} />
    </ModelReprocessDialogContext.Provider>
  );
};
